/// Centralized URL configuration for the Hidatsa website
// This file manages all API and asset URLs for different environments

const CONFIG = {
  // Environment detection
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',

  // API path prefix
  // Default is "/api/v1" (matches backend controllers). Override via REACT_APP_API_PATH_PREFIX if needed.
  API_PATH_PREFIX: process.env.REACT_APP_API_PATH_PREFIX || '/api/v1',

  // New domain configuration (for reference)
  DOMAINS: {
    FRONTEND: 'https://hidatsaaabaci.org',
    API: 'https://hidatsaaabaci.org', // API is served from the same domain via CloudFront
    ASSETS: 'https://assets.hidatsaaabaci.org'
  },

  // Environment-specific API base URLs
  API: {
    // Reads the variable from .env file
    BASE_URL: process.env.REACT_APP_API_BASE_URL, 
    
    ENDPOINTS: {
      LESSONS: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/lessons`,
      DICTIONARY: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/dictionary`,
      FLASHCARDS: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/flashcards`,
      CURRICULUM: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/curriculum`,
      DOCUMENTS: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/documents`,
      EMPLOYEES: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/employees`,
      BLOG: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/blog`,
      CALENDAR: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/calendar/events`,
      ALPHABET: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/alphabet`,
      CONTENT: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/content`,
      ADMIN_BLOG_POSTS: `${process.env.REACT_APP_API_PATH_PREFIX || '/api/v1'}/admin/blog/posts`,
      USER_CRED_API: '/api/auth/user_cred'
    }
  },

  // Asset configuration
  ASSETS: {
    BASE_URL: process.env.REACT_APP_ASSETS_URL,
    PATHS: {
      AUDIO: '/audio',
      IMAGES: '/images',
      DOCS: '/docs',
      LESSONS: '/lessons'
    }
  },
  
  HTTP: {
    TIMEOUT: 10000,
    WITH_CREDENTIALS: true,
    HEADERS: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  }
};

// Helper functions 
export const getApiUrl = (endpoint = '') => {
  // In production, BASE_URL is "", so this returns "/api/v1/...".
  // In development, BASE_URL is "http://localhost:8080", so this returns "http://localhost:8080/api/v1/...".
  const baseUrl = CONFIG.API.BASE_URL || ''; // Default to empty string if undefined
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${baseUrl}${cleanEndpoint}`;
};

export const getAssetUrl = (assetPath = '') => {
  const baseUrl = CONFIG.ASSETS.BASE_URL || '';
  const cleanPath = assetPath.startsWith('/') ? assetPath : `/${assetPath}`;
  return `${baseUrl}${cleanPath}`;
};

export const getAudioUrl = (filename) => {
  return getAssetUrl(`${CONFIG.ASSETS.PATHS.AUDIO}/${filename}`);
};

export const getImageUrl = (filename) => {
  return getAssetUrl(`${CONFIG.ASSETS.PATHS.IMAGES}/${filename}`);
};

export const getDocUrl = (filename) => {
  return getAssetUrl(`${CONFIG.ASSETS.PATHS.DOCS}/${filename}`);
};

/**
 * Build a URL for a lesson asset on S3/CloudFront.
 * @param {string} s3BasePath - e.g. "level-1/lesson-07"
 * @param {string} filename - e.g. "sections/s01.html" or "games/match.json"
 * @returns full CDN URL to the lesson asset
 */
export const getLessonAssetUrl = (s3BasePath, filename) => {
  return getAssetUrl(`${CONFIG.ASSETS.PATHS.LESSONS}/${s3BasePath}/${filename}`);
};

// Export the main config object
export default CONFIG;